export default __webpack_public_path__ + "static/media/work_ec-prodcts.5d3be10b.jpg";